import React from "react";
import { Link } from "react-router-dom";

export default function ServicesSection(props) {
  const advancelink =
    "/advancedsearch/" + (props.searchterm ? props.searchterm : "");
  const directPurchaselink =
    "/directpurchaselink/" + (props.searchterm ? props.searchterm : "");
  const digitalreportslink =
    "/digitalreportslink/" + (props.searchterm ? props.searchterm : "");

  return (
    <>
      <div className="app-wrapper">
        <div className="app-content pt-3 p-md-3 p-lg-4 ">
          <div className="container-xl">
            <h1 className="app-page-title mb-0">Services</h1>
            <hr className="mb-4" />
          </div>

          <div className="col-md-10 pt-5">
            <div className="row ">
              <div className="col-xl-4 col-lg-6">
                <div className="card l-bg-cherry">
                  <div className="card-statistic-3 p-4">
                    <div className="mb-4 mt-4 text-center">
                      <Link
                        className="stretched-link text-dark"
                        to={advancelink}
                      >
                        <h5 className="card-title mb-0 text-white">
                          Advanced Search
                        </h5>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="card l-bg-blue-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="mb-4 mt-4 text-center">
                      <Link
                        className="stretched-link text-dark"
                        to={directPurchaselink}
                      >
                        <h5 className="card-title mb-0 text-white">
                          Direct Purchase Links
                        </h5>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="card l-bg-green-dark">
                  <div className="card-statistic-3 p-4">
                    <div className="mb-4 mt-4 text-center">
                      <Link
                        className="stretched-link text-dark"
                        to={digitalreportslink}
                      >
                        <h5 className="card-title mb-0 text-white">
                          Digital Report Links
                        </h5>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
